export class Roledata {

   
    id:number;
    name: string;
    description:string;


}
